import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronDownIcon } from '@utils/icons';
import type { IHelpNode } from './helpTree';
import { HelpGuideIcon } from './helpIcons';
import styles from './GuideReaderPage.module.css';

interface IGuideRailProps {
  tree: IHelpNode[];
  slug: string;
  /** The open family (the parent of the current guide, or the guide itself if it is a parent). */
  familySlug: string | null;
}

export function GuideRail({ tree, slug, familySlug }: IGuideRailProps) {
  const { t } = useTranslation();
  return (
    <nav className={styles.rail} aria-label={t('help.guides')}>
      <Link to="/help" className={styles.back}>
        <span className={styles.backCaret}><ChevronDownIcon size={14} /></span>
        {t('help.allGuides')}
      </Link>
      <h4>{t('help.guides')}</h4>
      {tree.map((node) => {
        const open = node.guide.slug === familySlug;
        return (
          <div key={node.guide.slug}>
            <Link to={`/help/${node.guide.slug}`} className={node.guide.slug === slug ? styles.on : undefined}>
              <HelpGuideIcon iconKey={node.guide.iconKey} />
              <span className={styles.grow}>{node.guide.title}</span>
              {node.children.length > 0 ? (
                <span className={`${styles.caret} ${open ? '' : styles.caretShut}`}><ChevronDownIcon size={14} /></span>
              ) : null}
            </Link>
            {open ? (
              <div className={styles.railKids}>
                {node.children.map((child) => (
                  <Link key={child.slug} to={`/help/${child.slug}`} className={child.slug === slug ? styles.on : undefined}>
                    <HelpGuideIcon iconKey={child.iconKey} size={15} />
                    {child.title}
                  </Link>
                ))}
              </div>
            ) : null}
          </div>
        );
      })}
    </nav>
  );
}
